import { React, lazy, Suspense } from "react";
import Header from "./header";
const Factories = lazy(() => import("./factories"));

function FactoriesPage() {
  return (
    <Suspense fallback={<div>Loading Component</div>}>
      <Header from="factories" />
      <Factories source="factories" />
    </Suspense>
  );
}

export default FactoriesPage;
